import type { SVGProps } from "react";

const RadioIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_64_15358)">
        <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="7.25" fill="white" />
        <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="7.25" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="8" cy="8" r="3" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_64_15358">
          <rect width="17" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RadioIcon;
